import { groupsHavePermission } from "../../auth/permissions";

/**
 * Whether a sidebar menu item shows for a user with the given cognito groups.
 * Items with a `requiredPermission` need a role (including the implicit
 * authenticated role every signed-in user holds) that grants it, so they stay
 * hidden when groups are missing. Every other item shows for everyone.
 *
 * @param {Object} item - A SliderMenu entry or sub-menu entry.
 * @param {Array} groups - The user's cognito groups.
 * @returns {Boolean}
 */
export const isMenuItemVisible = ({ requiredPermission }, groups) =>
  !requiredPermission || groupsHavePermission(groups, requiredPermission);
